import { Component,OnInit,OnDestroy,AfterViewInit,Input,Pipe,PipeTransform } from '@angular/core';
import { NgbModal,NgbActiveModal,ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import { Subject } from 'rxjs';

@Component({
    selector: "loading-spin-modal"
    ,templateUrl: "./loading.spin.modal.component.html"
})
export class LoadingSpinModalComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;

    constructor(
        public activeModal: NgbActiveModal
    ) {
        
    }

    ngOnInit() {
        
    }
    
    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    clickCancel(){
        this.activeModal.close({
            "type":"cancel"
        });
    }
}